import React from 'react';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import CurrentInsuranceInputComponent from '../../../../input/company-scan-inputs/current-insurances/CurrentInsuranceInputComponent';
import { insurancePoliciesQuestionId } from '../../constants/hardcodedFlowIds';

interface Props {
  question: FlowsQuestion;
}

const HardcodedQuestionPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (question.id) {
    case insurancePoliciesQuestionId:
      return <CurrentInsuranceInputComponent />;
    default:
      return null;
  }
};

export default HardcodedQuestionPicker;
